import React, { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";

const CompanyDropdown = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const [hoverIndex, setHoverIndex] = useState(null);

    const sections = [
        { title: "About Us", slug: "about-us", bg: "#B0E0A4" },
        { title: "Join Our Team", slug: "join-Our-team", bg: "#F7C5D9" },
    ];

    const defaultBg = "#ECEAEB";

    const currentCompanyName = decodeURIComponent(location.pathname.replace("/company/", ""));
    const isMobile = window.innerWidth < 1024;

    return (
        <div
            style={{
                width: "100%",
                maxWidth: "1000px",
                backgroundColor: "#fff",
                borderRadius: "12px",
                padding: "1.5rem",
                boxShadow: "0px 4px 12px rgba(0,0,0,0.06)",
                zIndex: 9999,
                margin: "0 auto",
            }}
        >
            <div
                style={{
                    display: "flex",
                    flexDirection: "row",
                    gap: "1.5rem",
                    flexWrap: "wrap",
                    justifyContent: "space-between",
                }}
            >
                {/* Left Section */}
                <div
                    style={{
                        display: "flex",
                        flexDirection: "column",
                        gap: "1rem",
                        flex: 1,
                        maxwidth: "260px",
                        flexShrink: 0,
                    }}
                >
                    {sections.map((item, idx) => {
                        const isHovered = hoverIndex === idx;
                        const isActive = currentCompanyName === item.slug;
                        // const bgColor = isHovered ? "#D2D2D2" : isActive ? item.bg : defaultBg;
                        const bgColor = isHovered ? "#D2D2D2" : isActive ? item.bg : defaultBg;
                        return (
                            <div
                                key={idx}
                                style={{
                                    backgroundColor: isMobile ? "none" : bgColor,
                                    padding: "20px",
                                    borderRadius: isMobile ? "0" : "6px",
                                    cursor: "pointer",
                                    display: "flex",
                                    justifyContent: "space-between",
                                    alignItems: "center",
                                    transition: "all 0.3s ease",
                                    height: window.innerWidth < 1024 ? "80px" : "",
                                    boxShadow: !isMobile && (isHovered || isActive ? "0 4px 12px rgba(0,0,0,0.12)" : "none"),
                                    borderBottom: isMobile ? "1px solid #f0f0f0" : "none",
                                }}
                                onClick={() => navigate(`/company/${item.slug}`)}
                                onMouseEnter={() => setHoverIndex(idx)}
                                onMouseLeave={() => setHoverIndex(null)}
                            >
                                <span
                                    style={{
                                        fontSize: isMobile ? "34px" : "18px",
                                        fontWeight: "600",
                                        color: isMobile && isActive ? "#F00D69" : "#111827",
                                    }}
                                >
                                    {item.title}
                                </span>
                                <img
                                    src="/assets/fonts/icons/RightIcon.png"
                                    alt="arrow"
                                    style={{ width: "8px", height: "10px" }}
                                />
                            </div>
                        );
                    })}
                </div>

                {/* Right Section */}
                {!isMobile && (
                    <div
                        style={{
                            backgroundColor: "#BDEDB2",
                            padding: "20px",
                            borderRadius: "8px",
                            display: "flex",
                            flexDirection: "column",
                            justifyContent: "center",
                            alignItems: "center",
                            textAlign: "center",
                            width: "220px",
                            flexShrink: 0,
                        }}
                    >
                        <div
                            style={{
                                backgroundColor: "#fff",
                                padding: "20px 16px",
                                borderRadius: "12px",
                                width: "100%",
                            }}
                        >
                            <p
                                style={{
                                    fontSize: "10px",
                                    color: "#000",
                                    marginBottom: "12px",
                                    fontWeight: "400"
                                }}
                            >
                                Be a part of a Ravity Journey
                            </p>
                            <button onClick={() => navigate("/company/join-Our-team")}
                                style={{
                                    backgroundColor: "#111",
                                    color: "#fff",
                                    border: "none",
                                    borderRadius: "4px",
                                    padding: "10px 20px",
                                    fontSize: "16px",
                                    fontWeight: "400",
                                    cursor: "pointer",
                                    width: "128px",
                                }}
                            >
                                View All
                            </button>
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
};

export default CompanyDropdown;
